import * as React from 'react';
import clsx from 'clsx';

function BoltIcon({ className, stroke = 'currentColor', ...props }) {
  return (
    <svg
      className={clsx('w-4 h-4', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BoltIcon;
